import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

type CompetitionPropsType = {
    list: { description: string }[];
};
const Competition = ({ list }: CompetitionPropsType) => {
    return (
        <div className="aimed-competition-page">
            <FullWrapper isMargin={false} className="aimed-competition-pageCase">
                <div className="aimed-competition-pageWrapper">
                    <div className="aimed-competition-pageMainTitle">
                        Проведение конкурса AI&rsquo;m Finder
                    </div>
                    <div className="aimed-competition-pageDescription">
                        14&nbsp;ноября 2023 состоялся финал конкурса-сателлита AI&rsquo;m Finder,
                        который проходил в&nbsp;прямом эфире в&nbsp;течение 2&nbsp;часов. Финалисты
                        одновременно определяли симптомы для каждого тестового пациента
                        с&nbsp;помощью разработанных ИИ-систем. На&nbsp;это им&nbsp;отводилась всего
                        1&nbsp;минута. Платформа сравнивала, насколько разметка симптомов от&nbsp;ИИ
                        близка к&nbsp;результату врача.
                    </div>
                    <div className="aimed-competition-pagePirpleBlock">
                        <div className="aimed-competition-pageParagraf">
                            В&nbsp;рамках финальных испытаний мы&nbsp;обеспечили работоспособность
                            платформы и&nbsp;ее&nbsp;отказоустойчивость:
                        </div>
                    </div>
                    <div className="aimed-competition-pageList">
                        {list &&
                            list.map(item => (
                                <div key={item.description} className="aimed-competition-pageItem">
                                    <div className="aimed-competition-pageCircle"></div>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                        className="aimed-competition-pageText"
                                    ></div>
                                </div>
                            ))}
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Competition;
